/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-19 15:54:08
 * @LastEditTime: 2024-02-29 17:07:08
 * @Descripttion: file content
 */
import {combineReducers} from 'redux'
import userReducer from './userReducer'
import commReducer from './commReducer'
import homeworkReducer from './homeworkReducer'
import storage from 'redux-persist/es/storage'
import {persistReducer} from 'redux-persist'

const persistUserConfig = {
	key: 'user',
	storage,
	whitelist: ['tea']
}
const persistHomeworkReducerConfig = {
	key: 'homework',
	storage,
	whitelist: ['mode', 'data']
}
const persistCommReducerConfig = {
	key: 'comm',
	storage,
	whitelist: ['token', 'acc_type']
}

const persistedUserReducer = persistReducer(persistUserConfig, userReducer)
const persistedHomeworkReducerReducer = persistReducer(persistHomeworkReducerConfig, homeworkReducer)
const persistedCommReducerReducerReducer = persistReducer(persistCommReducerConfig, commReducer)

const RootReducer = combineReducers({
	user: persistedUserReducer,
	homework: persistedHomeworkReducerReducer,
	comm: persistedCommReducerReducerReducer
})

// 导出所有reducer
export default RootReducer
